import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "37",
  height: "23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("rect", {
        width: "36.703",
        height: "22.022",
        fill: "#26337A",
        rx: "4"
      }),
      _createElementVNode("path", {
        fill: "#FFFFFE",
        d: "m15.228 14.515 1.129-7h1.803l-1.128 7zM23.575 7.686a4.5 4.5 0 0 0-1.616-.294c-1.784 0-3.039.95-3.05 2.31-.01 1.007.896 1.568 1.58 1.903.703.342.94.562.937.868-.005.47-.561.684-1.08.684-.722 0-1.106-.106-1.7-.367l-.231-.112-.253 1.567c.421.195 1.2.365 2.01.374 1.896 0 3.127-.939 3.142-2.392.006-.798-.475-1.402-1.516-1.902-.63-.324-1.017-.54-1.012-.868 0-.291.326-.603 1.033-.603.59-.009 1.017.127 1.35.27l.162.08zM25.977 12.033c.15-.403.719-1.957.719-1.957-.01.018.149-.406.24-.668l.121.604s.347 1.67.418 2.02zm2.226-4.512h-1.394c-.433 0-.756.124-.946.58l-2.679 6.416h1.895s.31-.863.38-1.052l2.31.003c.054.245.22 1.05.22 1.05h1.674zM13.715 7.52l-1.766 4.773-.19-.97c-.328-1.118-1.352-2.33-2.498-2.937l1.615 6.123 1.91-.001 2.84-6.988z"
      }),
      _createElementVNode("path", {
        fill: "#EC982D",
        d: "M10.31 7.515H7.401l-.024.145c2.264.58 3.761 1.98 4.383 3.663l-.632-3.217c-.11-.444-.426-.575-.818-.59"
      })
    ], -1)
  ]))]))
}
export default { render: render }